import { KMSwal } from "../../app";
import { ajaxPost, ajaxErrorAlert, toggleBetweenElements } from "../utils";

const loginForm = $("#loginForm");

if (loginForm) {
  const changePasswordForm = $("#changePasswordForm"),
    loginOtpForm = $("#loginOtpForm"),
    userFirstName = $(".userFirstName");

  loginForm.on("submit", (e) => {
    e.preventDefault();
    const form = $(e.target);
    form.loading({ extraClasses: "w110" });

    ajaxPost(form.attr("action"), form.serializeArray(), loginForm)
      .then((responseData) => {
        if (responseData["user_must_change_password"] === true) {
          userFirstName.html(String(responseData["user_first_name"]));
          $("#old_password").val($("#password").val());
          toggleBetweenElements(loginForm, changePasswordForm);
        } else if (responseData["with_otp"] === true) {
          changePasswordForm.hide();
          userFirstName.html(String(responseData["user_first_name"]));
          toggleBetweenElements(loginForm, loginOtpForm, 500, () => {
            $("input[name=otp]").trigger("focus");
          });

          loginOtpForm.loading({ action: "hide" });
        } else {
          form.loading({
            loadingText: "Yönləndirilir...",
            position: "center",
            extraClasses: "w110",
          });
          window.location.href = String(responseData["redirect_url"]);
        }
      })
      .catch((errors) => {
        ajaxErrorAlert(errors, form);
      });
  });

  changePasswordForm.on("submit", (e) => {
    e.preventDefault();
    const form = $(e.target);
    form.loading({ extraClasses: "w110" });
    const data = {
      next: $("input[name=next]").val(),
      external: $("input[name=external]").val(),
      csrfmiddlewaretoken: $("input[name=csrfmiddlewaretoken]").val(),
      username: $("input[name=username]").val(),
      password: $("input[name=old_password]").val(),
      new_password1: $("input[name=new_password1]").val(),
      new_password2: $("input[name=new_password2]").val(),
    };

    ajaxPost(form.attr("action"), data, changePasswordForm)
      .then((responseData) => {
        if (responseData["with_otp"] === true) {
          $("input[name=password]").val(data.new_password2);
          loginForm.trigger("submit");
        } else {
          form.loading({
            loadingText: "Yönləndirilir...",
            position: "center",
            extraClasses: "w110",
          });
          window.location.href = String(responseData["redirect_url"]);
        }
      })
      .catch((errors) => {
        ajaxErrorAlert(errors, form);
      });
  });

  loginOtpForm.on("submit", (e) => {
    e.preventDefault();
    const form = $(e.target);
    form.loading({ extraClasses: "w110" });
    const data = {
      csrfmiddlewaretoken: $("input[name=csrfmiddlewaretoken]").val(),
      otp: $("input[name=otp]").val(),
      next: $("input[name=next]").val(),
      username: $("input[name=username]").val(),
      password: $("input[name=password]").val(),
    };

    ajaxPost(form.attr("action"), data, loginOtpForm)
      .then((responseData) => {
        form.loading({
          loadingText: "Yönləndirilir...",
          position: "center",
          extraClasses: "w110",
        });
        window.location.href = String(responseData["redirect_url"]);
      })
      .catch((errors) => {
        ajaxErrorAlert(errors, form);
      });
  });

  $("#backToLogin").on("click", () => {
    toggleBetweenElements(loginOtpForm, loginForm, 500, () => {
      loginOtpForm.children(".alertWrapper").remove();
    });
    loginForm.loading({ action: "hide" });
  });
}
